{
  "title": "Bàn giao bệnh nhân (I-PASS)",
  "illnessSeverity": "Mức độ nặng của bệnh",
  "patientSummary": "Tóm tắt bệnh nhân",
  "actionList": "Danh sách hành động",
  "situationAwareness": "Nhận thức tình huống",
  "synthesis": "Tổng hợp bởi người nhận",
  "acknowledge": "Xác nhận bàn giao",
  "severity": {
    "stable": "Ổn định",
    "watcher": "Cần theo dõi",
    "unstable": "Không ổn định"
  },
  "loading": "Loading handoffs…",
  "errorState": "Could not load handoffs.",
  "emptyState": "No handoffs waiting for you.",
  "unknownPatient": "Unknown patient",
  "from": "Handed over by {{name}}",
  "openChart": "Open chart",
  "notProvided": "Not provided",
  "noActions": "No actions listed.",
  "noContingency": "No contingency plan was given. Ask the outgoing clinician what to watch for.",
  "synthesisHint": "Read back what you understood. This is the step the protocol exists to force.",
  "synthesisPlaceholder": "In my own words, the plan is…",
  "acknowledgedAt": "Acknowledged {{when}}",
  "toast": {
    "acknowledged": "Handoff acknowledged",
    "acknowledgeFailed": "Could not acknowledge the handoff"
  },
  "ipass": {
    "illness": "I — Illness severity",
    "patientSummary": "P — Patient summary",
    "actionList": "A — Action list",
    "situationAwareness": "S — Situation awareness",
    "contingencyPlan": "S — Contingency plan",
    "synthesis": "S — Synthesis by receiver"
  }
}
